import { DemoRoutes } from '../router.types';

export const demoRoutes: DemoRoutes = {
  contentSearchAutocomplete: `/demo/content-search-autocomplete`,
};
